import service from '@/store/services/device-firmware-versions-service';

const state = {
    list: {},
    deviceFirmwareVersion: {},
    importResult: {},
    meta: {},
    alert: {
        id: null,
        message: '',
        type: "warning"
    },
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, deviceFirmwareVersion) => {
        state.deviceFirmwareVersion = deviceFirmwareVersion;
    },
    SET_IMPORT_RESULT: (state, result) => {
        state.importResult = result;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_ALERT: (state, alert) => (state.alert = alert),
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((deviceFirmwareVersion) => { commit('SET_RESOURCE', deviceFirmwareVersion); });
    },

    multipleAdd({ commit }, params) {
        return service.multipleAdd(params)
            .then((result) => { commit("SET_IMPORT_RESULT", result); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((deviceFirmwareVersion) => { commit('SET_RESOURCE', deviceFirmwareVersion); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    setAlert({ commit, dispatch }, alert) {
        setTimeout(()=>{
            alert.message = '';
            alert.id = null;
        }, 8000)
        commit('SET_ALERT', alert);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    deviceFirmwareVersion: state => state.deviceFirmwareVersion,
    url: state => state.url,
    importResult: state => state.importResult,
    alert: state => state.alert,
};

const deviceFirmwareVersion = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default deviceFirmwareVersion;